/* requires:
polyfill.js
*/

const loginForm = {
  init: function (formSetting) {
    const { theForm } = formSetting;
    if (!theForm) {
      return false;
    }
    this.validateOnBlur(theForm);
    this.checkAuthState();

    // listening for click on the submit button
    const submitBtn = theForm.querySelector("button[type=submit]");
    const showPasswordTrigger = theForm.querySelector(".show-forgot-password");
    const hidePasswordTrigger = theForm.querySelector(".hide-forgot-password");
    const loginFormFields = theForm.querySelector("#login");
    const forgotFormFields = theForm.querySelector("#forgotPassword");
    
    submitBtn.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        const isFormValid = loginForm.isFormValid(theForm);
        if (!isFormValid) {
          alert("The highlighted field/s are required.");
          return false;
        } else {
          loginForm.submit(formSetting);
        }
      },
      true
    );
    showPasswordTrigger.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        loginFormFields.classList.add("d-none");
        forgotFormFields.classList.remove("d-none");
        loginForm.isLogin = false;
      },
      true
    );
    hidePasswordTrigger.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        loginFormFields.classList.remove("d-none");
        forgotFormFields.classList.add("d-none");
        loginForm.isLogin = true;
      },
      true
    );

    const logoutLinks = document.querySelectorAll(".logout-link");
    for (let logoutLink of logoutLinks) {
      logoutLink.addEventListener( "click", function (e) {
        e.preventDefault();
        loginForm.logout();
      }, true );
    }
  },
  isLogin: true,
  checkAuthState: function() {
    const sessionAuth = sessionStorage.getItem("sessionAuth");
    const isLoggedOutEl = document.querySelectorAll(".is-logged-out");
    const isLoggedInEl = document.querySelectorAll(".is-logged-in");
    if (sessionAuth === "true") {
      for (let element of isLoggedOutEl) {
        element.classList.add("d-none");
      }
      for (let element of isLoggedInEl) {
        element.classList.remove("d-none");
      }
    }
    else {
      for (let element of isLoggedOutEl) {
        element.classList.remove("d-none");
      }
      for (let element of isLoggedInEl) {
        element.classList.add("d-none");
      }
    }
  },
  validateOnBlur: function (theForm) {
    if (!theForm) {
      return false;
    }
    // realtime form fields validation using blur event
    const fields = theForm.querySelectorAll(".required");
    for (let field of fields) {
      const type = field.type;
      if (type === "email") {
        field.addEventListener(
          "blur",
          function (e) {
            const x = field.value;
            const re =
              /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(x)) {
              field.classList.add("is-invalid");
            } else {
              field.classList.remove("is-invalid");
            }
          },
          true
        );
      } else if (type === "tel") {
        field.addEventListener(
          "blur",
          function (e) {
            const x = field.value;
            const re = /[(]?\d{3}[)]?\s?-?\s?\d{3}\s?-?\s?\d{4}/;
            if (!re.test(x)) {
              field.classList.add("is-invalid");
            } else {
              field.classList.remove("is-invalid");
            }
          },
          true
        );
      } else {
        field.addEventListener(
          "blur",
          function (e) {
            const x = field.value;
            if (!x || $.trim(x) == "") {
              field.classList.add("is-invalid");
            } else {
              field.classList.remove("is-invalid");
            }
          },
          true
        );
      }
    }
  },
  isFormValid: function (theForm) {
    if (!theForm) {
      return false;
    }
    // form fields validation during submission
    const fields = theForm.querySelectorAll(".required");
    let isFormValid = true;
    for (let field of fields) {
      // if field is visible
      if (field.offsetParent !== null) {
        const type = field.type;
        if (type === "email") {
          const x = field.value;
          const re =
            /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!re.test(x)) {
            field.classList.add("is-invalid");
            isFormValid = false;
          } else {
            field.classList.remove("is-invalid");
          }
        } else if (type === "tel") {
          const x = field.value;
          const re = /[(]?\d{3}[)]?\s?-?\s?\d{3}\s?-?\s?\d{4}/;
          if (!re.test(x)) {
            field.classList.add("is-invalid");
            isFormValid = false;
          } else {
            field.classList.remove("is-invalid");
          }
        } else {
          const x = field.value;
          if (!x || $.trim(x) == "") {
            field.classList.add("is-invalid");
            isFormValid = false;
          } else {
            field.classList.remove("is-invalid");
          }
        }
      }
    }
    return isFormValid;
  },
  submit: function (formSetting) {
    const { theForm } = formSetting;

    const formMsg = theForm.querySelector(".form-msg");
    const formRawData = new FormData(theForm);

    // generate form fields data for submission
    const fields = {};
    for (let pair of formRawData.entries()) {
      // console.log(pair[0] + ", " + pair[1]);
      fields[pair[0]] = pair[1];
    }

    // submit form data
    const formLoginData = {
      key: "ajax_moodle_authentication",
      username: fields.loginUsername,
      password: fields.loginPassword,
    };
    const formForgotData = {
      key: "ajax_moodle_forgotpassword",
      email: fields.loginEmail,
    };

    const formData = loginForm.isLogin
      ? formLoginData
      : !loginForm.isLogin
      ? formForgotData
      : {};

    // url needs to be relative to where the site is
    // const postUrl = `${window.location.protocol}://${window.location.host}/training/login/AYPOOutsideAuthentication.php`;
    fetch('/training/login/AYPOOutsideAuthentication.php',
      {
        method: "POST", // or 'PUT'
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify(formData),
      }
    )
      .then(checkFetchStatus)
      .then((data) => {
        if (data.status) {
          // console.log('Success:', data);
          // show form success message
          formMsg.classList.remove("alert", "alert-danger");
          formMsg.classList.add("alert", "alert-success");
          formMsg.innerHTML = loginForm.isLogin ? "Login successful." : !loginForm.isLogin ? "If there was an email address registered on that account, you have been sent an email with your credentials." : '';
          sessionStorage.setItem('sessionAuth', data.status);
          loginForm.checkAuthState();
          theForm.reset();
          location.reload()
        } else if (!data.status) {
          // show form error message
          sessionStorage.setItem('sessionAuth', data.status);
          loginForm.checkAuthState();
          formMsg.classList.remove("alert", "alert-success");
          formMsg.classList.add("alert", "alert-danger");
          formMsg.innerHTML = `<span>Invalid username or password.</span>`;
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
  logout: function() {
    fetch('/training/login/AYPOOutsideAuthentication.php',
      {
        method: "POST", // or 'PUT'
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({"key":"ajax_moodle_logout"}),
      }
    )
      .then(checkFetchStatus)
      .then((data) => {
        if (data.status) {
          sessionStorage.setItem('sessionAuth', false);
          loginForm.checkAuthState();
          location.reload()
        } else if (!data.status) {
          // show form error message
          sessionStorage.setItem('sessionAuth', data.status);
          loginForm.checkAuthState();
          location.reload()
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
};
